import { DashboardConstants } from '../../actions/constant';

const {
  GET_GAME_BY_INTERVENTION_REQUEST,
  GET_GAME_BY_INTERVENTION_SUCCESS,
  GET_GAME_BY_INTERVENTION_FAILURE,
  GET_GAME_BY_INTERVENTION_LOADER,
  GET_GAME_BY_INTERVENTION_RESET,
} = DashboardConstants;
const intitialstate: object = {
  response: null,
  getGames: false,
  loading: false,
};

export const dashboardGamesInterventionReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_GAME_BY_INTERVENTION_SUCCESS: {
      return {
        ...state,
        getGames: true,
        response: action.payload?.data,
        loading: false,
      };
    }

    case GET_GAME_BY_INTERVENTION_FAILURE:
      return {
        ...state,
        getGames: false,
        response: action.payload,
        loading: false,
      };

    case GET_GAME_BY_INTERVENTION_LOADER:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
